import React, { lazy } from 'react'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { LazyRoute } from 'Modules'

const LibraryContainerLazy = lazy(() => import('../containers/Library.container'))

export const LibraryRoutes = [
	<LazyRoute
		exact
		path={FrontUrls.neo_library}
		lazyComponent={LibraryContainerLazy}
		key={FrontUrls.neo_library}
	/>,
]
